import React from "react";

const FACES = [
  { emoji: "😀", label: "No pain" },
  { emoji: "🙂", label: "Mild" },
  { emoji: "🙂", label: "Mild-moderate" },
  { emoji: "😐", label: "Moderate" },
  { emoji: "😐", label: "Moderate" },
  { emoji: "😟", label: "Moderate-severe" },
  { emoji: "😟", label: "Severe" },
  { emoji: "😣", label: "Severe" },
  { emoji: "😖", label: "Very severe" },
  { emoji: "😫", label: "Very severe" },
  { emoji: "😭", label: "Worst possible" },
];

const isValidScore = (v) =>
  typeof v === "number" && Number.isInteger(v) && v >= 0 && v <= 10;

const NumericalPainScale = ({ painScore, setPainScore }) => {
  const getColor = (i) => {
    if (i === 0) return "#4caf50";
    if (i <= 3) return "#8bc34a";
    if (i <= 6) return "#ffc107";
    if (i <= 8) return "#ff9800";
    return "#f44336";
  };

  const currentFace = isValidScore(painScore) ? FACES[painScore] : null;

  return (
    <div className="p-3">
      {/* Face impression */}
      <div className="text-center mb-3">
        <div
          style={{
            fontSize: "3.5rem",
            lineHeight: 1,
            transition: "transform 0.15s ease",
            transform: currentFace ? "scale(1.1)" : "scale(1)",
          }}
          aria-hidden="true"
        >
          {currentFace ? currentFace.emoji : "🙂"}
        </div>
        <div
          className="my-2"
          style={{
            fontSize: "0.9rem",
            fontWeight: 600,
            color: currentFace ? getColor(painScore) : "#868e96",
            minHeight: "1.2em",
          }}
        >
          {currentFace ? currentFace.label : "Select a level"}
        </div>
      </div>

      <div
        role="radiogroup"
        aria-label="Pain scale from 0 to 10"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(38px, 1fr))",
          gap: "6px",
        }}
      >
        {Array.from({ length: 11 }, (_, i) => {
          const selected = painScore === i;
          return (
            <button
              key={i}
              type="button"
              role="radio"
              aria-checked={selected}
              aria-label={`Pain level ${i} - ${FACES[i].label}`}
              onClick={() => setPainScore(i)}
              style={{
                aspectRatio: "1 / 1",
                minWidth: "38px",
                borderRadius: "8px",
                border: selected ? "2px solid #212529" : "1px solid #ced4da",
                background: selected ? getColor(i) : "#fff",
                color: selected ? "#fff" : "#495057",
                fontWeight: 600,
                fontSize: "0.95rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                transition: "all 0.15s ease",
              }}
              onMouseEnter={(e) => {
                if (!selected) e.currentTarget.style.borderColor = "#868e96";
              }}
              onMouseLeave={(e) => {
                if (!selected) e.currentTarget.style.borderColor = "#ced4da";
              }}
            >
              {i}
            </button>
          );
        })}
      </div>

      <div className="d-flex justify-content-between mt-2">
        <small className="text-muted">0 = No pain</small>
        <small className="text-muted">10 = Worst possible pain</small>
      </div>
    </div>
  );
};

export default NumericalPainScale;
